<div class="mt-5 flex flex-column">
  <div class="text-lg-semibold text-gray-900">Svi zahtevi</div>
  <div class="mt-3 flex flex-column lg:flex-row lg:align-items-center justify-content-between gap-3">
    <p-tabs class="transparent" [value]="0" (valueChange)="onTabChange($event)">
      <p-tablist>
        <p-tab [value]="0">
          <div class="flex align-items-center">
            <app-loading-01 stroke="#7E838F"></app-loading-01>
            <div class="ml-2 text-sm-semibold">U procesu</div>
            @if (inProcessCount) {
              <p-badge
                class="ml-2"
                styleClass="in-process-badge"
                [value]="inProcessCount"
              />
            }
          </div>
        </p-tab>
        <p-tab [value]="1">
          <div class="flex align-items-center">
            <app-clock-rewind stroke="#7E838F"></app-clock-rewind>
            <div class="ml-2 text-sm-semibold">Istorija</div>
          </div>
        </p-tab>
      </p-tablist>
    </p-tabs>
    <div class="search-input">
      <app-text-input
        [hasIcon]="true"
        ctrlPlaceholder="Pretraga"
        formCtrlClass="table-search-input"
        shortcutHint="⌘K"
        [formCtrl]="searchFormCtrl | formControl"
      >
        <app-search stroke="#ADB0B8"></app-search>
      </app-text-input>
    </div>
    <div class="flex flex-column sm:flex-row align-items-stretch sm:align-items-center gap-2">
      <app-client-type-dropdown [reset]="resetCounter"
                                (onSelect)="onClientTypeChange($event)"></app-client-type-dropdown>
      <app-package-status-dropdown [reset]="resetCounter"
                                   (onSelect)="onStatusChange($event)"></app-package-status-dropdown>
    </div>
  </div>
  @if (hasActiveFilters) {
    <div class="mt-3-5 flex justify-content-end align-items-center">
      <div class="text-sm-semibold text-red-600 cursor-pointer" (click)="resetFilters()">Resetuj filtere</div>
    </div>
  }

  <app-data-table
    class="mt-3-5 packages-table"
    [value]="packages"
    [first]="first"
    [rows]="paginatedData.pageSize!"
    [totalRecords]="paginatedData.totalCount!"
    [isLoading]="isLoading"
    [tableStyleClass]="packages.length === 0 ? 'hide-header' : ''"
    [hasPreviousPage]="!!paginatedData.hasPreviousPage"
    [hasNextPage]="!!paginatedData.hasNextPage"
    (lazyLoad)="loadMeetingsLazy($event)"
    (prevPage)="prev()"
    (nextPage)="next()"
  >
    <!-- HEADER -->
    <ng-template #tableHeader>
      <tr>
        <th>
          <div class="text-xs-semibold text-gray-400">KLIJENT</div>
        </th>
        <th>
          <div class="text-xs-semibold text-gray-400">PAKET</div>
        </th>
        <th>
          <div class="text-xs-semibold text-gray-400">DATUM ZAHTEVA</div>
        </th>
        <th>
          <div class="text-xs-semibold text-gray-400">STATUS</div>
        </th>
        <th class="actions-col">
          <div class="text-xs-semibold text-gray-400">{{ activeTab === 0 ? 'AKCIJE' : 'POSLEDNJA AKCIJA' }}</div>
        </th>
      </tr>
    </ng-template>

    <!-- BODY -->
    <ng-template #tableBody let-pckg>
      <tr class="cursor-pointer" (click)="routeToPackageDetails(pckg.id)">
        <td>
          <div class="flex align-items-center">
            <div class="icon">
              @if (pckg.isCompany) {
                <app-building-05 stroke="#ADB0B8"></app-building-05>
              } @else {
                <app-user-circle stroke="#ADB0B8"></app-user-circle>
              }
            </div>
            <div class="ml-2-5 flex flex-column gap-1">
              <div class="text-sm-medium text-gray-900">{{ pckg.name }}</div>
              <div class="text-sm-medium text-gray-500">{{ pckg.isCompany ? 'Pravno lice' : 'Fizičko lice' }}</div>
            </div>
          </div>
        </td>
        <td>
          <div class="text-sm-medium text-gray-900">{{ pckg.packageName }}</div>
        </td>
        <td>
          <div class="text-sm-medium text-gray-900">{{ getDateFormatedWithTime(pckg.createdOn) }}</div>
        </td>
        <td>
          <div class="status-cell">
            <p-chip
              [label]="pckg.status.description"
              [class]="getStatusChipClass(pckg.status.value)"
            >
            </p-chip>
          </div>
        </td>
        <td>
          @if (activeTab === 0) {
            <div class="flex align-items-center">
              @if (pckg.status.value === UserPackageStatus.NEW) {
                <app-button [btnSeverity]="ButtonSeverity.PRIMARY" [btnSize]="ButtonSize.SM"
                            (btnClicked)="openInvoiceDialog(pckg.id, pckg.packagePrice); $event.stopPropagation()">
                  <app-send-01 stroke="white"></app-send-01>
                  <div class="text-sm-semibold text-white">Pošalji fakturu</div>
                </app-button>
              } @else if (pckg.status.value === UserPackageStatus.INVOICE_SENT) {
                <app-button [btnSeverity]="ButtonSeverity.SUCCESS" [btnSize]="ButtonSize.SM"
                            (btnClicked)="openInvoicePaidDialog(pckg.id); $event.stopPropagation()">
                  <app-check-circle stroke="white"></app-check-circle>
                  <div class="text-sm-semibold text-white">Potvrdi uplatu</div>
                </app-button>
              }
              <app-button class="ml-2-5" [btnSeverity]="ButtonSeverity.SECONDARY" [btnSize]="ButtonSize.SM"
                          (btnClicked)="openCancelDialog(pckg.id); $event.stopPropagation()">
                <app-slash-circle-01 stroke="#181D27"></app-slash-circle-01>
              </app-button>
            </div>
          } @else {
            <div class="text-sm-medium text-gray-900">{{ getDateFormatedWithTime(pckg.lastActionDateTime) }}</div>
          }
        </td>
      </tr>
    </ng-template>

    <!-- EMPTY STATE -->
    <ng-template #tableEmpty>
      <div class="flex justify-content-center align-items-center text-gray-900 text-lg-semibold py-5">
        Nema zahteva
      </div>
    </ng-template>

    <!-- LOADING SKELETON -->
    <ng-template #tableLoading>
      @for (row of [1, 2, 3, 4, 5, 6]; track row) {
        <tr>
          <td>
            <div class="flex align-items-center gap-2">
              <p-skeleton shape="circle" size="2rem"></p-skeleton>
              <p-skeleton width="6rem"></p-skeleton>
            </div>
          </td>
          <td>
            <p-skeleton width="8rem" class="mb-2"></p-skeleton>
          </td>
          <td>
            <p-skeleton width="5rem" height="1.5rem"></p-skeleton>
          </td>
          <td>
            <p-skeleton width="6rem"></p-skeleton>
          </td>
          <td>
            <p-skeleton width="8rem" class="mb-1"></p-skeleton>
          </td>
          <td>
            <p-skeleton shape="circle" size="1rem"></p-skeleton>
          </td>
          <td>
            <p-skeleton shape="circle" size="1rem"></p-skeleton>
          </td>
          <td>
            <p-skeleton shape="circle" size="1rem"></p-skeleton>
          </td>
        </tr>
      }
    </ng-template>
  </app-data-table>
</div>

@if (selectedCommand()) {
  <app-invoice-sent-dialog
    [(isVisible)]="showInvoiceDialog"
    [command]="selectedCommand()!"
    (submitted)="setInvoiceSent($event)" />
}

@if (selectedId()) {
  <app-confirm-payment-dialog
    [(isVisible)]="showConfirmPaymentDialog"
    (confirmed)="setAsPaid()"
    (cancelled)="showConfirmPaymentDialog.set(false); selectedId.set(undefined)"
  ></app-confirm-payment-dialog>
}

<app-confirm-action-dialog
  [(isVisible)]="showCancelDialog"
  title="Odbijte zahtev"
  message="Da li ste sigurni da želite da odbijete zahtev za kupovinu paketa? Klijent će morati da pošalje novi zahtev."
  confirmLabel="Odbij zahtev"
  (confirmed)="confirmCancel()"
  (cancelled)="closeCancelDialog()"
></app-confirm-action-dialog>
